<template>
  <div class="row settings">
    <div class="col-md-2 s-menu">
      <b-nav vertical>
        <b-nav-item
          :to="'/principal/settings/general'"
          class="nav-item"
          exact
          exact-active-class="sidebar-active-link"
        >
          <span class="title">General</span>
        </b-nav-item>
        <b-nav-item
          :to="'/principal/settings/members'"
          class="nav-item"
          exact
          exact-active-class="sidebar-active-link"
        >
          <span class="title">Miembros</span>
        </b-nav-item>
        <b-nav-item
          :to="'/principal/settings/log'"
          class="nav-item"
          exact
          exact-active-class="sidebar-active-link"
        >
          <span class="title">Registro</span>
        </b-nav-item>
      </b-nav>
    </div>
    <div class="col-md-10">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { BNav, BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNav,
    BNavItem
  }
}
</script>
